/** @module Classes */ /** typedoc */
/**
 * Represents the preferences of the current user session.
 * @note Incomplete for now, as not 100% moved to Falcor.
 */
class SessionPreferences {
    constructor() {
        /**
         * Indicates if automatic mastering is enabled or not.
         *
         * When `true`, it will skip the preview for a new track upload,
         * and perform the mastering right away.
         */
        this.hasAutomaticMastering = false;
        /**
         * Indicates the default mastering intensity to use when automatic
         * mastering is enabled.
         */
        this.defaultMasteringIntensity = null;
        /**
         * Indicates the default mastering style to use when automatic
         * mastering is enabled.
         */
        this.defaultProductionStyle = null;
        /**
         * Indicates if the user receives notifications on electron.
         */
        this.hasDesktopNotifications = true;
        /**
         * Whether a user is subscribed to the personalized tips email list
         */
        this.isSubscribedToPersonalizedTips = null;
        /**
         * Whether a user is subscribed to the LANDR updates email list
         */
        this.isSubscribedToLandrUpdates = null;
        /**
         * Whether a user is subscribed to the LANDR newsletters email list
         */
        this.isSubscribedToLandrNewsLetter = null;
        /**
         * Whether a user is subscribed to the LANDR samples newsletters email list
         */
        this.isSubscribedToLandrSamplesNewsLetter = null;
        /**
         * Whether a user is subscribed to the LANDR exclusive promotions email list
         */
        this.isSubscribedToLandrExclusivePromotions = null;
        /**
         * The user prefers to view the Mastering Preview in Basic|Advanced mode
         */
        this.hasPreviewAdvancedMode = null;
    }
}

export { SessionPreferences };
